import { render } from "./AllProjects.vue?vue&type=template&id=bdf44272&scoped=true"
import script from "./AllProjects.vue?vue&type=script&lang=js"
export * from "./AllProjects.vue?vue&type=script&lang=js"

import "./AllProjects.vue?vue&type=style&index=0&id=bdf44272&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf44272"]])

export default __exports__